export const EDUCATIONALSUPPORTS = "/api/educational_support"
export const EDUCATIONALSUPPORT = "/api/educational_support/:param"

export const EDUCATIONALSUPPORT_ACTIVATE = "/api/educational_support/:param/activate"
export const EDUCATIONALSUPPORT_DEACTIVATE = "/api/educational_support/:param/deactivate"
export const EDUCATIONALSUPPORT_DELETE = "/api/educational_support/:param/delete"